import {
  ColumnFiltersState,
  getCoreRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  PaginationState,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
import { useRef, useState } from "react";
import columns from "./columns";
import { MainTable } from "@/components/main-table";
import TablePagination from "@/components/table-pagination";
import { useSweepsReports } from "@/queries/sweeps/sweeps-reports/list";
import { useAuth } from "@/providers/auth";

const fallbackData = [];

export default function SweepsActivityTable() {
  const { cognitoId, clientId, userRole } = useAuth();
  const userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const sweepsReportsQuery = useSweepsReports(userId);
  const tableRef = useRef(null);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [sorting, setSorting] = useState<SortingState>([
    { id: "initiated_on", desc: true }
  ]);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const table = useReactTable({
    data: sweepsReportsQuery.data || fallbackData,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    state: {
      sorting,
      pagination,
      columnFilters,
    },
  });

  return (
    <div className="space-y-4 mb-96">
      <MainTable
        ref={tableRef}
        table={table}
        isLoading={sweepsReportsQuery.isLoading}
      />
      <TablePagination table={table} />
    </div>
  );
}
